import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37d005aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./nutritionalDistribution.scss?vue&type=style&index=0&id=37d005aa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d005aa",
  null
  
)

export default component.exports